// extracted by mini-css-extract-plugin
module.exports = {"schoolLink":"_28fl_-0OqiyB4-m5diAC4p"};